module.exports = __webpack_public_path__ + "img/more-active.ca2ac8d3.png";